module.exports = "img/flags/MU.3b57dcb.png";